import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { TcComunidadAutonomaViewModel } from '../comunidadautonoma.types';
import { ComunidadAutonomaService } from '../comunidadautonoma.service';


@Component({
    selector: 'app-comuniddadautonoma-wrapper-edit',
    templateUrl: './comunidadautonoma-wrapper-edit.component.html'
})
export class ComunidadAutonomaWrapperEditComponent extends ComponentBase implements OnInit {

    visibilitySpinner = false;
    comunidadAutonoma: TcComunidadAutonomaViewModel;
    formGroup: FormGroup;

    /*messageErrorAlreadyExist = 'Ya existe esta Declaración Suplementaria';*/
    successMessage = 'Email guardado correctamente';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.getComunidadAutonoma(id);
        }
    });


    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private comunidadAutonomaService: ComunidadAutonomaService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                Id: [null],
                Email: [null],
                Descripcion: [{value: null, disabled: true}],

            }),
        });
    }

    
    private getComunidadAutonoma(id: number): void {
        this.comunidadAutonomaService
            .getComunidadAutonoma(id)
            .pipe(
                tap((ca: TcComunidadAutonomaViewModel) => {
                    this.comunidadAutonoma = ca;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onSave(): void {

        this.visibilitySpinner = true;
        const model: TcComunidadAutonomaViewModel = { ...this.formGroup.value.basic };
        this.comunidadAutonomaService
            .saveComunidadAutonoma(model)
            .pipe(
                tap(res => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate(['/mantenimiento/general/comunidadautonoma']);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }
}
